import { render, staticRenderFns } from "./BsListTileTitle.vue?vue&type=template&id=2dbc5594&scoped=true&"
import script from "./BsListTileTitle.vue?vue&type=script&lang=js&"
export * from "./BsListTileTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc5594",
  null
  
)

export default component.exports